import './scss/App.scss';
import { Menu } from './components/Menu';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { Home } from './pages/Home';
import { Administrator } from './pages/Administrator';
import ProtectedRoute from './ProtectedRoute';
import AdminRoute from './AdminRoute';
import { LandingPage } from './pages/LandingPage';
import { toast } from 'react-toastify';
import { Marketplace } from './pages/Marketplace';
import { About } from './pages/About';
toast.configure({
    autoClose: 2500,
});

export const PATHS = {
  LandingPage: '/',
  About: '/about-us',
  Home: '/home',
  Marketplace: '/marketplace',
  Administrator: '/administrator',
};

function App() {
    return ( <div className = "App" >
        <BrowserRouter >
            <Menu />
            <Switch >
                <Route exact path={PATHS.LandingPage} component={LandingPage}/> 
                <Route exact path={PATHS.About} component={About}/> 
                <ProtectedRoute exact path={PATHS.Home} component={Home} /> 
                <ProtectedRoute exact path={PATHS.Marketplace} component={Marketplace} /> 
                <AdminRoute exact path={PATHS.Administrator} component={Administrator} /> 
                <Redirect to = "/" />
            </Switch> 
        </BrowserRouter> </div>
    );
}

export default App;
